import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

const levels = ['off', 'info', 'warn', 'error'] as const;
const levelDefinition = { type: 'enum' as const, values: levels };

export const FCM_CORGI_REQUEST_PROVIDER_LOGGING_CONFIG = defineFcm('corgi_request_provider_logging_config')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				logLevel: {
					type: 'object',
					shape: {
						status: {
							type: 'object',
							shape: {
								default: levelDefinition,
								groups: {
									type: 'record',
									keys: ['1xx', '2xx', '3xx', '4xx', '5xx'] as const,
									optionalValues: true,
									shape: {
										type: 'object',
										shape: {
											default: levelDefinition,
											codes: { type: 'record', shape: levelDefinition },
										},
									},
								},
							},
						},
						error: {
							type: 'object',
							shape: {
								default: levelDefinition,
								codes: { type: 'record', shape: levelDefinition },
							},
						},
						retry: levelDefinition,
						cache: {
							type: 'object',
							shape: {
								hit: levelDefinition,
							},
						},
					},
				},
			},
		}),
	)
	.withDefault({
		logLevel: {
			status: {
				default: 'off',
				groups: {
					'1xx': { default: 'off', codes: {} },
					'2xx': { default: 'off', codes: {} },
					'3xx': { default: 'off', codes: {} },
					'4xx': { default: 'off', codes: {} },
					'5xx': { default: 'warn', codes: {} },
				},
			},
			error: {
				default: 'warn',
				codes: {},
			},
			retry: 'off',
			cache: {
				hit: 'off',
			},
		},
	})
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-middle-end',
		context: 'middle-end (RequestProvider)',
		description: `Used to configure the logging levels of requestProvider and serviceRequestProvider

		Log levels:
		- status: logging levels for response status codes
		- error: logging levels for errors (ETIMEDOUT, ECONNREFUSED, etc.)
		- retry: logging level for retries without success
		- cache: logging level for cache usage (e.g. cache hits)

		Valid values for each level are: 'off', 'info', 'warn', 'error'

		⚠️ Only global group is supported.`,
		template: {
			logLevel: {
				status: {
					default: 'off',
					groups: {
						'1xx': {
							default: 'off',
							codes: {},
						},
						'2xx': {
							default: 'off',
							codes: {},
						},
						'3xx': {
							default: 'off',
							codes: {},
						},
						'4xx': {
							default: 'off',
							codes: {},
						},
						'5xx': {
							default: 'warn',
							codes: {},
						},
					},
				},
				error: {
					default: 'warn',
					codes: {},
				},
				retry: 'off',
				cache: {
					hit: 'off',
				},
			},
		},
	});
